var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Flipbook',{ref:"flipbook",staticClass:"flipbook",attrs:{"pages":_vm.pages(_vm.$i18n.locale),"zooms":_vm.zooms,"perspective":_vm.perspective}})}
var staticRenderFns = []

export { render, staticRenderFns }